// pdp vide tab 
$(document).ready(function() {
  if ($('.tab_nav').length > 0) {
    $('.tab_nav > li > a').click(function(event) {
        event.preventDefault(); // Stop browser default behavior for anchor click
        
        // Get the currently active tab content selector
        var active_tab_selector = $('.tab_nav > li.active > a').attr('href');
        
        // Remove 'active' class from the currently active navigation
        var actived_nav = $('.tab_nav > li.active');
        actived_nav.removeClass('active');
        
        // Add 'active' class to the clicked navigation
        $(this).parents('li').addClass('active');
        
        // Hide the currently active tab content
        $(active_tab_selector).removeClass('active').addClass('hide');
        
        // Show the target tab content
        var target_tab_selector = $(this).attr('href');
        $(target_tab_selector).removeClass('hide').addClass('active');
    });

    // Move '.shop-pay-wrap' before '.product__description'
    $('.shop-pay-wrap').insertBefore('.product__description');
}


   jQuery('.retreat-carousel').slick({
        centerMode: true,
    centerPadding: '10vw',
    slidesToShow: 1,
    slidesToScroll: 1,
     dots: true,
      arrows:false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '10vw',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '7vw',
          slidesToShow: 1
        }
      }
    ]
      });
  
  });

// Related Products Slider
$(window).on("load", function() {
 /* setTimeout(() => {
    console.log("Hello after 2 seconds");
    $('.related-products-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      arrows: false,
      centerMode: true,
      focusOnSelect: true,
      centerPadding: '5vw',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '10vw'
          }
        }
      ]
    });
  }, 3000); */

  
});


// Related Products Slider
$(window).on("load", function() {
  var slide_count = $('.related-blog-slider .related-blogs__card').length;
  if(slide_count > 2){
    $('.related-blog-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      arrows:false,
      centerMode: true,
      focusOnSelect: true,
      centerPadding:'5vw',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
             centerPadding:'10vw',
          }
        }
      ]
    });
}
  });

  //PLP dropdown
  $(document).ready(function() {
    $("#dropdown-content").hide();

  // Toggle dropdown on button click
  $(".dropdown-toggle").click(function(event) {
    event.preventDefault();  // Prevents page refresh
    $("#dropdown-content").slideToggle();  // Toggle the dropdown
  });
  });


   $(document).ready(function(){
     
  

     $(".box-circle").each(function() {
      let i = 0,
        that = $(this),
        circleBorder = that.find(".circle-border"),
        borderColor = circleBorder.data("color1"),
        animationColor = circleBorder.data("color2"),
        percentageText = that.find(".percentage"),
        percentage = percentageText.data("percentage"),
        degrees = percentage * 3.6;
        circleBorder.css({
            "background-color":  animationColor
      });

      setTimeout(function(){
          loopIt();
      }, 1);

    function loopIt(){
        i = i + 1;

        if (i < 0) {
            i = 0;
        }

        if (i > degrees) {
            i = degrees;
        }

        percentage = i / 3.6;
        percentageText.text(Math.round(percentage) + "%");  // Updated to round to nearest whole number

        if (i <= 180){
            circleBorder.css('background-image','linear-gradient(' + (90 + i) + 'deg, transparent 50%,' + borderColor + ' 50%),linear-gradient(90deg, ' + borderColor + ' 50%, transparent 50%)');
        } else {
            circleBorder.css('background-image','linear-gradient(' + (i - 90) + 'deg, transparent 50%,' + animationColor + ' 50%),linear-gradient(90deg, ' + borderColor + ' 50%, transparent 50%)');
        }

        setTimeout(function(){
            loopIt();
        }, 1);
      }
    });

      
    });
   
//Sliders    
   $(document).ready(function(){

     // Homepage - testimonial-slider.liquid Slider
     if ($('.testimonials-slider').length > 0) {
      $('.testimonials-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows:false,
        centerMode: true,
        focusOnSelect: true,
        centerPadding:'32vw',
        autoplay: true,
        autoplaySpeed: 2000,
         responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
               centerPadding:'10vw',
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
               centerPadding:'10vw',
            }
          }
        ]
      });
     };

    // Ads Page transformation-section.liquid Slider
    if ($('.transformation-section').length > 0) {
       $('.transformation-section .slider').slick({
          dots: true,
          arrows: false,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          focusOnSelect: true,
        });
       };

      // Homepage - collection-slider.liquid Slilder 
     if ($('.knives-collection-slider').length > 0 ){
      $('.knives-collection-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        arrows:false,
        centerMode: true,
        focusOnSelect: true,
        centerPadding:'5vw',
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
               centerPadding:'5vw',
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
               centerPadding:'10vw',
            }
          }
        ]
      });
   };


     // Homepage - image-text-slider.liquid Slider
     if($('.textslider-init').length > 0){
      $('.textslider-init').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows:false,
        centerMode: false,
        focusOnSelect: true,
      });
     };       

    // Homepage -  result-overview.liquid Slider
     if($('.result-overiview-slider').length > 0) {
      $('.result-overiview-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows:false,
          centerMode: true,
          focusOnSelect: true,
          centerPadding:'5vw',
          autoplay: true,
          autoplaySpeed: 2000
      });
     };
     
    });





